import { createSelector } from "reselect";

const selectAssigments = (state) => state.assigments;

export const selectMyAssigments = createSelector(
  [selectAssigments],
  (assigments) => assigments.myAssigments
);
